module.exports = __webpack_public_path__ + "media/chosen-js/chosen-sprite@2x-a0b7f3f1.png";